import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

function ApiGridError(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
}

ApiGridError.displayName = 'ApiGridError';
export { ApiGridError };